import api from './api';

// Service du module « Relances Atelier » (suivi des passages atelier / révisions).
const relancesApi = {
  // Liste de travail (worklist) paginée + filtres.
  getVehicules: (params) => api.get('/suivi-revisions/vehicules', { params }),

  // Compteurs de charge (dépassées / ≤30 j / ≤60 j) — onglet À contacter.
  getStats: (params) => api.get('/suivi-revisions/stats', { params }),

  // VN vendus jamais venus en atelier (worklist dédiée).
  getJamaisRevenus: (params) => api.get('/suivi-revisions/jamais-revenus', { params }),

  // Détail d'un véhicule : historique des passages + suivi de contact.
  getVehicule: (chassis) => api.get(`/suivi-revisions/vehicules/${encodeURIComponent(chassis)}`),

  // Enregistre le suivi de contact (statut / canal / note).
  setContact: (chassis, payload) =>
    api.post(`/suivi-revisions/vehicules/${encodeURIComponent(chassis)}/contact`, payload),

  // Resynchronise la base Passages depuis le SFTP.
  sync: () => api.post('/suivi-revisions/sync'),

  // Seuils de calcul (km / mois).
  getConfig: () => api.get('/suivi-revisions/config'),

  // Liste des marques distinctes (filtre, communes aux 2 onglets).
  getMarques: () => api.get('/suivi-revisions/marques'),

  // Suppression (super-admin, mode édition).
  remove: (chassis) => api.delete('/suivi-revisions/vehicules', { data: { chassis } }),

  // Base d'exclusion (code client × concession), 2026-10-23.
  getExclusions: (params) => api.get('/suivi-revisions/exclusions', { params }),
  ajouterExclusions: (payload) => api.post('/suivi-revisions/exclusions', payload),
  retirerExclusion: (id) => api.post(`/suivi-revisions/exclusions/${id}/retirer`),

  getRelanceModele: () => api.get('/suivi-revisions/relance-sms/modele'),
  setRelanceModele: (modele) => api.put('/suivi-revisions/relance-sms/modele', { modele }),
  envoyerRelanceRdv: (chassis, payload) => api.post(`/suivi-revisions/vehicules/${encodeURIComponent(chassis)}/relance-sms`, payload),
  // Brique A97 RGPD : envoi du formulaire de consentement (tél. + SMS) au mobile du véhicule.
  demanderConsentement: (chassis, payload) => api.post(`/suivi-revisions/vehicules/${encodeURIComponent(chassis)}/consentement/demander`, payload || {}),
};

export default relancesApi;
